import React, { useState, useEffect } from "react";
import { ApiPost } from "../../service/ApiService";
import { Container, Form, Button, Alert, Card } from "react-bootstrap";

const PasswordHandler = () => {
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [isReset, setIsReset] = useState(false); // Determines if it's a reset or first-time set
  const [isForbidden, setIsForbidden] = useState(false); // Determines if the URL is invalid

  // Validate URL format and parse parameters
  const validateAndParseUrl = () => {
    const url = window.location.pathname;
    const params = new URLSearchParams(window.location.search);
    const validPaths = ["/dmz/reset-password", "/dmz/set-password"];
    if (!validPaths.includes(url)) {
      setIsForbidden(true);
      setMessage("403 Forbidden: Invalid URL path.");
      return;
    }

    const emailParam = params.get("email");
    const tokenParam = params.get("token");

    if (!emailParam || !tokenParam) {
      setIsForbidden(true);
      setMessage("403 Forbidden: Missing required parameters.");
      return;
    }

    setEmail(emailParam);
    setToken(tokenParam);
    setIsReset(url === "/dmz/reset-password");
  };

  useEffect(() => {
    validateAndParseUrl();
  }, []);

  const passwordOk = (data) => {
    setMessage(data.message || "Parola a fost salvată cu succes!")
    window.location.href = "/login";
  }
  
  
  // Handle password submission
  const handleSubmit = () => {
    if (!newPassword || !confirmPassword) {
      setMessage("Te rog să completezi toate câmpurile.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setMessage("Parolele nu corespund");
      return;
    }

    const endpoint = isReset
      ? "/dmz-api/reset"
      : "/dmz-api/set";

    ApiPost(
      endpoint,
      { email, token, newPassword },
      (data) => {passwordOk(data)},
      (error) =>
        setMessage(error.response?.data?.message || "A apărut o eroare."),
    );
  };

  if (isForbidden) {
    return (
      <Container className="mt-5">
        <Alert variant="danger">{message}</Alert>
      </Container>
    );
  }

return (
    <Container className="mt-5 d-flex justify-content-center">
        <Card style={{ width: "30rem" }} className="shadow">
            <Card.Body>
                <Card.Title className="mb-4 text-center">
                    {isReset ? "Resetează parola" : "Setează parola"}
                </Card.Title>
                {message && <Alert variant="warning">{message}</Alert>}
                <Form>
                    <Form.Control type="hidden" value={token} disabled />
                    <Form.Group className="mb-3">
                        <Form.Label>Email-ul asociat contului</Form.Label>
                        <Form.Control type="email" value={email} disabled />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Parola</Form.Label>
                        <Form.Control
                            type="password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Confirmă parola</Form.Label>
                        <Form.Control
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                    </Form.Group>
                    <Button variant="primary" onClick={handleSubmit} className="w-100">
                        {isReset ? "Salvează" : "Salvează"}
                    </Button>
                </Form>
            </Card.Body>
        </Card>
    </Container>
);
};

export default PasswordHandler;